<p>{{'footer.content'|translate}}</p>
